import React, { Component } from 'react'
import propTypes from 'prop-types'
import { withRouter } from 'react-router'
import { inject } from 'mobx-react'
import { Formik, Form, Field } from 'formik'
import { updateOffice } from '@atheneum/api'
import Button from '@components/Button'
import FormError from '@components/FormError/FormError'
import pick from 'lodash/pick'
import AddressFields from '@components/Form/AddressFields'
import Input from '@components/Form/Input'
import RichTextEditor from '@components/Form/RichTextEditor'

class AtheneumOfficeForm extends Component {
  static propTypes = {
    atheneumOffice: propTypes.object,
    modalStore: propTypes.object,
    atheneumOfficeStore: propTypes.object,
    growlStore: propTypes.object
  }

  state = { error: null }

  saveOffice = officeData => {
    const { atheneumOffice } = this.props

    return atheneumOffice ? updateOffice(atheneumOffice.id, officeData) : null
  }

  handleSubmit = (values, actions) => {
    const { atheneumOfficeStore, growlStore, modalStore } = this.props

    this.saveOffice(values)
      .then(() => {
        atheneumOfficeStore.getAtheneumOffices()
        growlStore.showSuccess('Atheneum company saved')
        modalStore.close()
      })
      .catch(({ message }) => {
        this.setState({ error: message })
        actions.setSubmitting(false)
      })
  }

  getInitialValues = () => {
    const { atheneumOffice } = this.props

    let initialValues = {
      name: '',
      address: {
        address1: '',
        address2: '',
        city: '',
        postalCode: '',
        state: '',
        countryId: null,
        timezoneId: null
      },
      vatNumber: '',
      taxNumber: '',
      contactPhone: '',
      contactFax: '',
      contactEmail: '',
      accountingPhone: '',
      accountingEmail: '',
      managingDirectors: '',
      bankName: '',
      bankAddress: '',
      iban: '',
      swift: '',
      routingNumber: '',
      bankNameSecondary: '',
      bankAddressSecondary: '',
      accountNumber: '',
      swiftSecondary: '',
      accountNumberSecondary: '',
      interestParagraph: '',
      bankCurrencyWarning: '',
      accountingInfo: '',
      legalRegistrationNumber: '',
      entityName: '',
      ibanSecondary: ''
    }

    initialValues = atheneumOffice
      ? pick(atheneumOffice, Object.keys(initialValues))
      : initialValues

    return initialValues
  }

  render () {
    return (
      <div>
        <Formik
          initialValues={this.getInitialValues()}
          onSubmit={this.handleSubmit}
          render={form => (
            <div className='expert-form'>
              <h1 className='expert-form__title'>
                {this.props.atheneumOffice ? 'Edit office details' : ''}
              </h1>
              <FormError error={this.state.error} />
              <Form onSubmit={form.handleSubmit}>
                <div className='expert-form__section'>
                  <Field name='name' label='Name' component={Input} />
                  <Field
                    name='entityName'
                    label='Entity name'
                    component={Input}
                  />
                  <Field
                    name='legalRegistrationNumber'
                    label='Legal registration number'
                    component={Input}
                  />
                  <AddressFields
                    form={form}
                    name='address'
                    timezone
                    postalCode
                    address
                    secondaryAddress
                  />
                  <Field
                    name='vatNumber'
                    label='VAT number'
                    component={Input}
                  />
                  <Field
                    name='taxNumber'
                    label='Tax number'
                    component={Input}
                  />
                  <Field
                    name='contactPhone'
                    label='Contact information phone'
                    component={Input}
                  />
                  <Field
                    name='contactFax'
                    label='Contact information fax'
                    component={Input}
                  />
                  <Field
                    name='contactEmail'
                    label='Contact information email'
                    component={Input}
                  />
                  <Field
                    name='accountingPhone'
                    label='Accounting hotline phone'
                    component={Input}
                  />
                  <Field
                    name='accountingEmail'
                    label='Accounting hotline email'
                    component={Input}
                  />
                  <Field
                    name='managingDirectors'
                    label='Managing directors'
                    component={Input}
                  />
                  <Field name='bankName' label='Bank name' component={Input} />
                  <Field
                    name='bankAddress'
                    label='Bank address'
                    component={Input}
                  />
                  <Field name='iban' label='IBAN' component={Input} />
                  <Field name='swift' label='BIC/SWIFT' component={Input} />
                  <Field
                    name='accountNumber'
                    label='Account number'
                    component={Input}
                  />
                  <Field
                    name='routingNumber'
                    label='Routing number'
                    component={Input}
                  />
                  <Field
                    name='bankNameSecondary'
                    label='Bank name (second account)'
                    component={Input}
                  />
                  <Field
                    name='bankAddressSecondary'
                    label='Bank address (second account)'
                    component={Input}
                  />
                  <Field
                    name='ibanSecondary'
                    label='IBAN (second account)'
                    component={Input}
                  />
                  <Field
                    name='swiftSecondary'
                    label='BIC/SWIFT (second account)'
                    component={Input}
                  />
                  <Field
                    name='accountNumberSecondary'
                    label='Account number (second account)'
                    component={Input}
                  />
                  <Field
                    name='interestParagraph'
                    label='Interest paragraph (invoice)'
                    component={RichTextEditor}
                  />
                  <Field
                    name='bankCurrencyWarning'
                    label='Bank currency warning (invoice)'
                    component={RichTextEditor}
                  />
                  <Field
                    name='accountingInfo'
                    label='Accounting info (invoice)'
                    component={RichTextEditor}
                  />
                </div>
                <div className='expert-form__section'>
                  <Button
                    primary
                    submit
                    onClick={this.onSubmit}
                    disabled={form.isSubmitting}
                  >
                    Save
                  </Button>
                  <Button
                    onClick={this.props.modalStore.close}
                    disabled={form.isSubmitting}
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            </div>
          )}
        />
      </div>
    )
  }
}

AtheneumOfficeForm.defaultProps = {
  hideButtons: true,
  showCloseIcon: true,
  shouldCloseOnOverlayClick: false
}

export default withRouter(
  inject('modalStore', 'growlStore')(AtheneumOfficeForm)
)
